/** Textos de Talleres y Personalizados (Módulos Claros, 2026-11-01). Title Case, sin textos explicativos. */
const S = {
	title: "Talleres",
	nuevo: "Nuevo Taller",
	cerrar: "Cerrar",
	cancelar: "Cancelar",
	cargando: "Cargando…",
	vacio: "Sin Talleres",
	tabs: [
		{ key: "proximos", label: "Próximos" },
		{ key: "enCurso", label: "En Curso" },
		{ key: "terminados", label: "Terminados" },
		{ key: "anulados", label: "Anulados" }
	] as { key: "proximos" | "enCurso" | "terminados" | "anulados"; label: string }[],
	estadoTab: { proximos: "Próximo", enCurso: "En Curso", terminados: "Terminado", anulados: "Anulado" } as { [k: string]: string },
	col: { taller: "Taller", dias: "Días", maestra: "Maestra", inscritas: "Inscritas", cobrado: "Cobrado" },
	falta: (m: string) => `Falta ${m}`,
	segunDia: "Según el Día",
	sinDias: "Sin Días",
	// Formulario
	editar: "Editar",
	editarTaller: "Editar Taller",
	guardar: "Guardar",
	crear: "Crear Taller",
	siguiente: "Siguiente",
	atras: "Atrás",
	pasoDatos: "Datos",
	pasoDias: "Días",
	nombre: "Nombre",
	cursos: "Cursos",
	precio: "Precio",
	cupoMax: "Cupo",
	notas: "Notas",
	guardado: "Taller Guardado",
	creado: "Taller Creado",
	faltanDias: "Elige al menos un día con entrada y salida",
	faltaNombre: "Falta el nombre y el precio",
	// Ventana
	inscritasAsistencia: "Inscritas y Asistencia",
	dias: "Días",
	pagoMaestras: "Pago a Maestras",
	inscribir: "+ Inscribir",
	pasarLista: "Pasar Lista",
	invitar: "Invitar",
	editarDias: "Editar Días",
	listo: "Listo",
	anular: "Anular",
	anularTaller: "Anular Taller",
	anulado: "Taller Anulado",
	sinInscritas: "Sin Inscritas",
	vino: "Vino",
	falto: "Faltó",
	pagado: "Pagado",
	sinCobro: "Sin Cobro",
	baja: "Baja",
	bajaTitulo: (n: string) => `Baja de ${n}`,
	bajaNota: "Nota",
	bajaOk: "Alumna Dada de Baja",
	deBaja: "De Baja",
	porSolicitud: (n: number) => (n === 1 ? "1 por Solicitud" : `${n} por Solicitud`),
	creadoPor: "Creado",
	inscritasN: "Inscritas",
	ultimaLista: "Última Lista",
	vendio: "Vendió",
	precioMatriculada: "Matriculadas",
	cupo: "Cupo",
	cobrado: "Cobrado",
	// Días
	fecha: "Fecha",
	horario: "Horario",
	aula: "Aula",
	maestra: "Maestra",
	entrada: "Entrada",
	salida: "Salida",
	agregarDias: "Agregar Días",
	editarDia: "Editar Día",
	borrar: "Borrar",
	borrarDia: "Borrar Día",
	diaGuardado: "Día Guardado",
	diaBorrado: "Día Borrado",
	diasAgregados: (n: number) => (n === 1 ? "Día Agregado" : `${n} Días Agregados`),
	ninguna: "Sin Asignar",
	sinAula: "Sin Aula",
	sinMaestra: "Sin Maestra",
	nDias: (n: number) => (n === 1 ? "1 día" : `${n} días`),
	calendario: "Calendario",
	mesAnterior: "Mes Anterior",
	mesSiguiente: "Mes Siguiente",
	todosLos: (d: string) => `Todos los ${d} del Mes`,
	aplicarATodos: "Aplicar a Todos",
	horaMal: "Revisa",
	quitarDia: (d: string) => `Quitar ${d}`,
	tocaLosDias: "Sin Días",
	// Pasar Lista
	presentes: (a: number, b: number) => `${a} de ${b}`,
	sinDiaHoy: "Sin Día Hoy",
	// Pago a maestras
	formaPago: "Forma de Pago",
	planta: "De Planta",
	porHora: "Por Hora",
	sinForma: "Sin Definir",
	horas: "Horas",
	tarifa: "Tarifa",
	aPagar: "A Pagar",
	total: "Total",
	tarifaHora: "Tarifa por Hora",
	tarifaTaller: "Tarifa de Este Taller",
	// Inscribir
	inscribirTitulo: "Inscribir",
	buscarAlumna: "Nombre o Código",
	buscarBtn: "Buscar",
	sinResultados: "Sin Resultados",
	seCobra: "Se Cobra",
	motivoPrecio: "Motivo",
	inscrita: (n: string) => `${n} Inscrita`,
	inscritasOk: (a: number, s: number) => `Inscritas ${a}` + (s ? `, Sin Inscribir ${s}` : ""),
	// Qué Va a Pasar
	queVaAPasar: "Qué Va a Pasar",
	confirmar: "Confirmar",
	volver: "Volver",
	totalCobros: (m: string) => `Total ${m}`,
	nadaQueHacer: "Nada que Hacer",
	// Invitar
	invitarTitulo: "Invitar por WhatsApp",
	verDestinatarias: "Ver Destinatarias",
	destinatarias: (n: number) => (n === 1 ? "1 Destinataria" : `${n} Destinatarias`),
	yaInscrita: "Ya Inscrita",
	inscribirN: (n: number) => `Inscribir ${n}`,
	enviarInvitacion: (n: number) => `Enviar Invitación a ${n}`,
	crearPlantilla: "Crear Plantilla",
	elegirCurso: "Elige al menos un curso",
	colAlumna: "Alumna",
	colCurso: "Curso",
	colTel: "Teléfono",
	// Maestra en Asistencias
	misTalleres: "Mis Talleres",
	hoy: "Hoy"
};

export default S;
